import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-player-renderer',
  templateUrl: './player-renderer.component.html',
  styleUrls: ['./player-renderer.component.css']
})
export class PlayerRendererComponent  implements ICellRendererAngularComp {

  params: any;
  label!: string;

  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    this.params = params;
    return true;
  }

  /** Web Browser Player rows get an inline globe icon instead of the shared
   *  WEB_BROWSER_PLAYER.png (HTML5 shield logo) — same fix as onboarding-wizard's Step 3
   *  tile. Scoped to this renderer; the shared PNG asset itself is left untouched. */
  isWebPlayer(): boolean {
    return !!this.params?.data?.playerType?.toUpperCase().includes('WEB');
  }

  onClick($event: any) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    }
  }
}
